import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { getCurrentUserServer, type ServerCachedUser } from '@adornis/bh-util/util.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { mongo } from '../server/mongo.js';
import { TextMultipleLangItem } from './TextMultipleLangItem.js';

@Entity()
export class WorkshopNote extends MongoEntity {
  public static override _class = 'WorkshopNote';
  public static override _collectionName = 'workshop-notes';

  @Field(type => String)
  @validate(nonOptional())
  title!: string;

  @Field(type => Date, { default: v => v ?? new Date() })
  createdAt!: Date;

  @Field(type => [TextMultipleLangItem])
  translatedNoteHTML!: TextMultipleLangItem[];

  @validate(nonOptional())
  @Field(type => String)
  public workshopID!: string;

  @Field(type => Boolean, { default: v => v ?? false })
  adminOnly!: boolean;

  static override async beforeCreate(entity: WorkshopNote) {
    const user = await getCurrentUserServer();
    if (!user) throw new Error('User not found');
    if (user.isAdmin) entity.adminOnly = true;
  }

  static async getAllowedWorkshopNotes(user: ServerCachedUser) {
    const filter = (() => {
      const filter = {} as any;
      if (user.isAdmin) return {};
      filter.adminOnly = { $ne: true };
      return filter;
    })();

    const aggregation = [
      { $match: filter }, //
      { $group: { _id: null, ids: { $push: '$_id' } } },
    ];

    const workshopNoteCollection = mongo().collection(WorkshopNote._collectionName);
    const result = await workshopNoteCollection.aggregate(aggregation).toArray();
    return result.at(0)?.ids ?? [];
  }

  override toString() {
    return this.title ?? '';
  }
}
